export default "__VITE_ASSET__966DYQGTX6j6TKS3krX3vw__"